import { Link } from "react-router-dom";
import { IoReload } from "react-icons/io5";
import { useWorkShiftStore } from "../../../../hooks";
import { paginationOptions } from "../../../data";
import { SelectForm } from "../../../ui";

export const WorkShiftPagination = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    page,
    pageSize,
    totalPages,

    // Methods
    startChangePageSize,
    startChangePage,
    reloadWorkShifts,
    startRemovePage,
    startAddPage,
  } = useWorkShiftStore();

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  const onChangePageSize = ({ target }) => {
    startChangePageSize(target.value);
  };

  const onChangePage = (page) => {
    startChangePage(page);
  };

  // Efectos -----------------------------------------------//

  return (
    <div className="d-md-flex align-items-end text-center justify-content-between">
      <SelectForm
        label={`Registros por página`}
        options={paginationOptions}
        labelKey={"description"}
        name={`pageSize`}
        value={pageSize}
        onInputChange={onChangePageSize}
      />

      <ul className="pagination justify-content-center mb-0 mt-3 mt-sm-0">
        <Link
          to="#"
          className="btn btn-icon btn-pills btn-soft-primary me-4"
          onClick={() => reloadWorkShifts()}
        >
          <IoReload />
        </Link>
        <li className="page-item" onClick={() => startRemovePage()}>
          <Link className="page-link" to="#" aria-label="Previous">
            &lt;
          </Link>
        </li>
        {Array.from({ length: totalPages }, (_, index) => (
          <li
            key={index}
            className={`page-item ${
              parseInt(page) === index + 1 ? "active" : ""
            }`}
            onClick={() => onChangePage((index + 1).toString())}
          >
            <button className={`page-link`} to="#">
              {index + 1}
            </button>
          </li>
        ))}
        <li className="page-item" onClick={() => startAddPage()}>
          <Link className="page-link" to="#" aria-label="Next">
            &gt;
          </Link>
        </li>
      </ul>
    </div>
  );
};
